import { Button, Spin, Timeline, message } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { GetRequestDetailsAction } from "../../redux/order/order.action";
import ClientCalcStatuse from "./ClientCalcStatuse";
import moment from "moment";
import {
  CheckCircleFilled,
  ClockCircleFilled,
  CalendarOutlined,
  ClockCircleOutlined,
  FlagOutlined,
} from "@ant-design/icons";
import paper from "../../assets/paper.svg";
import { Link } from "react-router-dom";
import { UpdateOrderStatus } from "../../network/customer.network";

class ClientStatues extends Component {
  state = {
    showAdd: false,
    acceptLoading: false,
    myData: {},
  };

  handelShowInfo = (data) => {
    this.setState({ showAdd: false, myData: data === null ? {} : data });
    this.props.GetRequestDetailsAction(this.props.RequestDetails.Id);
  };

  handelChangeGenralStatus = (stateId) => {
    const { userData, orderId } = this.props;
    this.setState({ acceptLoading: true });
    UpdateOrderStatus(
      orderId,
      stateId,
      (res) => {
        this.setState({ acceptLoading: false });
        message.success("تم ارسال تأكيد موعد مقابلة البنك بنجاح");
        this.props.handelGetOrderDetails();
      },
      (err) => {
        this.setState({
          loadingOk: false,
          loadingCancel: false,
          loading: false,
        });
        //console.log(err);
      }
    );
  };

  render() {
    const { showAdd } = this.state;
    const {
      loading,
      StatusLogs,
      FinanceRequestStatuses,
      orderData,
      handelChangeTabs,
    } = this.props;
    // console.log(StatusLogs, "sadfsdfsd");
    console.log(orderData, "orderDataorderDataorderData");
    return (
      <Spin spinning={loading}>
        <div className="client-info-wrapper">
          <header className="client-header">
            <h2 className="header-title">حالات الطلب</h2>
          </header>
          <div className="user-statues-wrapper">
            {/* {
              StatusLogs &&
            <ClientCalcStatuse
            StatusLogs={StatusLogs} />
          } */}
            <Timeline mode={"right"}>
              {FinanceRequestStatuses?.map((s) => {
                if (
                  s?.Id === 1 ||
                  s?.Id === 2 ||
                  // s?.Id === 4 ||
                  s?.Id === 6 ||
                  s?.Id === 7 ||
                  s?.Id === 8
                ) {
                  return (
                    <Timeline.Item
                      dot={
                        orderData?.FinanceRequestStatus?.Id === s?.Id ? (
                          <ClockCircleFilled color="green" />
                        ) : (
                          orderData?.FinanceRequestStatus?.Id >= s?.Id && (
                            <CheckCircleFilled style={{ color: "green" }} />
                          )
                        )
                      }
                    >
                      {s?.NameLT}
                    </Timeline.Item>
                  );
                }
              })}
              {/* <Timeline.Item dot={<CheckCircleFilled />} color="green">
                Technical testing 2015-09-01
              </Timeline.Item> */}
            </Timeline>
            <div className="order-sm-summary">
              <div className="order-summary-row">
                <h5 className="order-sm-title">سعر السيارة : </h5>

                <h5 className="order-sm-title">
                  {orderData?.CarModel?.Price} <span>ر.س</span>{" "}
                </h5>
              </div>
              <div className="order-summary-row">
                <h5 className="order-sm-title">قيمة التمويل : </h5>
                <h5 className="order-sm-title">
                  {orderData?.FinancingValue} <span>ر.س</span>
                </h5>
              </div>
            </div>
            {(orderData?.FinanceRequestStatus?.Id === 7 ||
              orderData?.FinanceRequestStatus?.Id === 8) && (
              <div className="order-summary-actions">
                <div className="mapouter">
                  <div className="gmap_canvas">
                    <iframe
                      width={"400"}
                      height={"270"}
                      id="gmap_canvas"
                      src={
                        "https://maps.google.com/maps?q=Business%20Village%20-%20Port%20Saeed%20-%20Dubai&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      }
                      frameBorder="0"
                      scrolling="no"
                      marginHeight="0"
                      marginWidth="0"
                    ></iframe>
                    <br />
                  </div>
                </div>
                <div className="appointment-card-holder">
                  <div className="data-row">
                    <CalendarOutlined />
                    <p>
                      {" "}
                      {moment
                        .utc(orderData?.AppointmentDate?.CreationDate)
                        .local()
                        .format("YYYY/M/D")}
                    </p>
                  </div>
                  <div className="data-row">
                    <ClockCircleOutlined />
                    {orderData?.AppointmentDate && (
                      <p>
                        {moment
                          .utc(orderData?.AppointmentDate?.CreationDate)
                          .local()
                          .format("HH:MM a")}
                      </p>
                    )}
                  </div>
                  <div className="data-row">
                    <FlagOutlined />
                    <p>{orderData?.AppointmentAddress}</p>
                  </div>
                </div>
                {orderData?.FinanceRequestStatus?.Id === 7 && (
                  <>
                    <h4>في انتظار تأكيد موعد مقابلة البنك</h4>
                    <Button
                      type="primary"
                      loading={this.state.acceptLoading}
                      onClick={() => this.handelChangeGenralStatus(8)}
                    >
                      تاكيد
                    </Button>
                  </>
                )}
              </div>
            )}
            {(orderData?.FinanceRequestStatus?.Id === 1 ||
              orderData?.FinanceRequestStatus?.Id === 2 ||
              orderData?.FinanceRequestStatus?.Id === 3 ||
              orderData?.FinanceRequestStatus?.Id === 4) && (
              <div className="order-summary-actions">
                <img src={paper} alt="" />
                <h4>للاطلاع على تفاصيل الطلب </h4>
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    handelChangeTabs("5");
                  }}
                >
                  عرض الآن
                </Button>
              </div>
            )}
            {/* {StatusLogs?.map((Statuse) => {
              if (Statuse?.FinancingRequestGeneralStatusId === 31) {
                return (
                  <div className="calc-timeline is-osool-statues">
                    <div className="timeline-row-holder">
                      <p className="timeline--p">
                        {Statuse?.FinancingRequestGeneralStatus?.NameLT}
                      </p>
                      <time className="timeline--time">
                        {moment
                          .utc(Statuse?.CreationDate)
                          .local()
                          .format("YYYY/M/D - HH:MM")}
                      </time>
                    </div>
                  </div>
                );
              }
            })} */}
          </div>
        </div>
      </Spin>
    );
  }
}
const mapDispatchToProps = (dispatch) => ({
  GetRequestDetailsAction: (data) => dispatch(GetRequestDetailsAction(data)),
});
const mapStateToProps = (state) => ({
  RequestDetails: state.order.RequestDetails,
  FinanceRequestStatuses: state.user.metaData.FinanceRequestStatuses,
});
export default connect(mapStateToProps, mapDispatchToProps)(ClientStatues);
